import { render, staticRenderFns } from "./propertyQuote.vue?vue&type=template&id=67f0a42c&scoped=true"
import script from "./propertyQuote.vue?vue&type=script&lang=js"
export * from "./propertyQuote.vue?vue&type=script&lang=js"
import style0 from "./propertyQuote.vue?vue&type=style&index=0&id=67f0a42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0a42c",
  null
  
)

export default component.exports